<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper reset-wrapper ion-padding">
      

      <div class="container">

        <div class="auth-header">
            <div class="auth-heading">
                <h1>Verify Number</h1>
                <p class="auth-subtext">Verify Your Phone Number!</p>
            </div>
            <div class="brand-icon">
                <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
            </div>
        </div>
        <el-form
          class="full_page"
          :model="formsData.authForm"
          :rules="formsData.authForm.rules"
          :ref="(el) => (formsData.authForm.ref = el)"
          :label-position="'top'"
          @submit.prevent="goNext('authForm')"
          @keyup.enter="goNext('authForm')"
        >
          <div class="form_text">
            <div class="text mb-3">
              <span
                >For your security, we need to verify your phone number.
              </span>
            </div>
            <div class="text">
              <span>Please enter the code sent to </span>
              <span class="login">{{ mobileNumberDisplay }}</span>
            </div>
          </div>
          <confirm-code></confirm-code>
          <el-button
            type="link"
            class="confirm_numbers_resend verify__resend"
            @click="onResendConfirmationCode"
          >
           <i class="el-icon-refresh-left"></i>
            <span>Resend</span>
          </el-button>
          <el-form-item class="button_submit mb0">
            <el-button
              class="submit"
              type="blue"
              @click="goNext('authForm')"
              :disabled="formsData.authForm.disabled"
            >
              Continue
            </el-button>
          </el-form-item>
        </el-form>
        <div class="bg-overlay"></div>
      </div>
    </div>
    <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
    </div>
  </div>
</template>
  
  <script>
import ConfirmCodeComp from "@/components/ConfirmCode/ConfirmCode";

import { onMounted, provide, inject } from "vue";

import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { addIcons } from "ionicons";

import { arrowBackOutline } from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});

import { useStore } from "vuex";
import { useRouter } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

import parsePhoneNumber from "libphonenumber-js/mobile";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,

    "confirm-code": ConfirmCodeComp,
    SvgIcon
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const userData = $store.getters.GET_USER_DATA;
    const mobileNumberConversion = inject("mobileNumberConversion");
    const formatedMobile=mobileNumberConversion(userData);
    console.log("🚀 ~ setup ~ formatedMobile:", formatedMobile)
    const mobileNumber =
      $store.getters.getVerifyPageData.mobileNumber || formatedMobile;
    const formattedMobileNumber = mobileNumber
      ? parsePhoneNumber(mobileNumber).formatInternational()
      : null;

    const mobileNumberDisplay = formattedMobileNumber;

    const formsDataArray = {
      authForm: {
        confirm: {
          value: null,
          inputsValue: [],
          numberLength: 5,
          currentInput: 0,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "confirmNumbers",
                  callback,
                  setFormValidation
                );
              },
              trigger: ["enter"],
            },
          ],
        },
      },
    };

    const onResendConfirmationCode = async () => {
      try {
        await $store.dispatch("VERIFY_MOBILE_BANK_ACCOUNT", {
          phone: mobileNumber,
        });
      } catch (error) {
        console.log(error);
      }
    };

    const goBack = () => {
      $router.push({
        name: "profile",
      });
    };

    const goNext = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              let data = {
                code: getFormValues(formName).confirm,
              };
              await $store.dispatch("VERIFY_USER_MOBILE_FOR_BANK", data);

              $store.dispatch("clearVerifyPageData", {
                mobileNumber,
              });
              $router.push({
                name: "bank_account_edit",
              });
            } catch (error) {
              setFieldError(formName, "confirm", error.message);
              checkFormValidation(formName, true);
              console.log(error);
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    onMounted(() => {
      setFormRefs();
      formsRefs.authForm.value.$el[0].focus();
      checkFormValidation("authForm", false);
    });

    const {
      checkFormValidation,
      setFormValidation,
      setFieldError,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    provide("checkFormValidation", checkFormValidation);
    provide("setFormValidation", setFormValidation);
    provide("formsRefs", formsRefs);
    provide("confirm", formsData.authForm.confirm);
    provide("goNext", goNext);

    return {
      formsData,
      checkFormValidation,
      setFormValidation,
      goBack,
      goNext,
      mobileNumberDisplay,
      onResendConfirmationCode,
    };
  },
};
</script>
  